import { DrawerId } from "types/models";

/**
 * Generates drawer search param keys following the convention: {drawerId}-{suffix}
 *
 * @example
 * getDrawerSearchParams(DrawerId.EditCommission, 'id')
 * // Returns: ['EditCommission-id']
 *
 * @example
 * getDrawerSearchParams(DrawerId.FieldSettings, 'type', 'formFieldId', 'formStructureId')
 * // Returns: ['FieldSettings-type', 'FieldSettings-formFieldId', 'FieldSettings-formStructureId']
 */
export const getDrawerSearchParams = (drawerId: DrawerId, ...suffixes: string[]): string[] => {
    return suffixes.map((suffix) => `${drawerId}-${suffix}`);
};
